function init(){
const body = document.body;
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const mores = {
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const tags = [ 'INPUT', 'TEXTAREA' ];
const actions = {
	openModal: ({ openModal }) => {
		closeAllMenus();
		showModalById(openModal);
	},
}
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// 	'contact__country-time',
// ]);


for (const prop in menus) {
	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

setCooperateFormHandlers();
setToDirectorFormHandlers();
setBonusFormHandlers();
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
// setLanguagesAndLinks([
// 	...document.getElementsByClassName('header__language-list'),
// 	...document.getElementsByClassName('footer__language-list'),
// ]);
loadGoogleAnalytics();
body.addEventListener('click', (e) => {
	const { target } = e

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
body.addEventListener('click', createAnchorClickHandler(actions));
body.addEventListener('click', buttonClickHandler);
body.addEventListener('click', copyPromoToClipboardSimple);

setItiPhoneInputs(intlTelInput);

function setItiPhoneInputs (intlTelInput) {
	if (!intlTelInput) {
		return;
	}

	// const default_country_code = 'us';
	const setCountryCode = (country) => {
		intlTelInput(document.getElementById('cooperate_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
		intlTelInput(document.getElementById('to_director_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
	}

	getCountryCode().then(setCountryCode);
	// sendRequest('https://ipapi.co/json')
	// 	.then((res) => res.json())
	// 	.then(({ country_code }) => {
	// 		setCountryCode(country_code || default_country_code)
	// 	})
	// 	.catch(e => {
	// 		setCountryCode(default_country_code)
	// 	});
}
function buttonClickHandler (e) {
	const button = e.target.closest('button[type="button"]');
	const actions = {
		openModal: ({ openModal }) => {
			closeAllMenus();
			showModalById(openModal);
		},
	}

	if (!button) {
		return;
	}

	const { dataset } = button;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			actions[action](dataset);
		}
	}
}
function  setBonusFormHandlers () {
	const bonusForm = document.getElementsByClassName('popup__form')[1];

	if (!bonusForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'popup__form-group' });
	const hideInputError = hideError({ groupClass: 'popup__form-group' });
	const tags = [ 'INPUT', 'TEXTAREA' ];

	for (const element of bonusForm.elements) {
		const { tagName } = element;

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);
		}
	}

	bonusForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const body = validateForm(e.target);
		const { search } = window.location;

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({ target: input }));

			return;
		}

		showModalById('loader-modal');
		sendRequestAndSaveToken('/api/get_promo_code', {
			method: 'POST',
			body: JSON.stringify({ email: body.email, params: search }),
		}).then(({ response }) => {
			const loader = document.getElementById('loader-modal');

			hideCurrentModal({ target: loader });
			hideCurrentModal(e);

			if (!response || !response.success) {
				showModalById('error-modal');

				return;
			}

			const { code } = response;
			const codeElement = document.getElementsByClassName('popup__modal-code')[0];

			if (codeElement && codeElement.firstElementChild) {
				codeElement.firstElementChild.textContent = code;
			}

			showModalById('congratulations-modal');
			e.target.reset();
		}).catch(e => showModalById('error-modal'));
	});
}

function copyPromoToClipboard (e) {
	const promoCodeWrapper = e.target.closest('.popup__modal-code ');

	if (!promoCodeWrapper) {
		return;
	}

	const input = document.createElement('input');

	input.value = promoCodeWrapper.firstElementChild.textContent;
	document.body.appendChild(input)
	input.select()

	if (document.execCommand('copy')) {
		console.log("Done!")
	} else {
		console.log("Failed...")
	}

	document.body.removeChild(inp)
}

function copyPromoToClipboardSimple(e) {
	function legacyCopy(text) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
	}
	const wrapperClass = 'popup__modal-code';
	const promoCodeWrapper = e.target.closest('.' + wrapperClass);

	if (!promoCodeWrapper) {
		return;
	}

	const textToCopy = promoCodeWrapper.firstElementChild.textContent;

	if (navigator.clipboard && navigator.clipboard.writeText) {
		navigator.clipboard.writeText(textToCopy)
			.then(() => console.log('Copied!'))
			.catch(() => legacyCopy(textToCopy));
	} else {
		legacyCopy(textToCopy);
	}

	addClassToElement(promoCodeWrapper, wrapperClass, '--copied');
	debounce(setTimeout(removeClassFromElement, 1.5 * 1000,  promoCodeWrapper, wrapperClass, '--copied'), 2 * 1000);
}

function debounce(fn, delay) {
	let timeoutId;

	return function (...args) {
		clearTimeout(timeoutId);

		timeoutId = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}

}init();